import {priority} from '@priority-software/priority-proto-api/lib';

export const getColumnTypeKey = (value: priority.netitems.form.ColumnType = 1) => {
    return Object.keys(priority.netitems.form.ColumnType).find(
        key => priority.netitems.form.ColumnType[key] === value
    );
};
